import {ButtonProps, useListContext, useNotify, Button as ButtonRA} from "react-admin";
import {client} from "../../dataProvider";
import {useState} from "react";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Select, Typography
} from "@material-ui/core";
import {IoMdAddCircleOutline} from "react-icons/io";
import MenuItem from "@material-ui/core/MenuItem";


export const CreateDeliveryToBlock = (props: ButtonProps) => {
    const notify = useNotify();
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState("A");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const [loading, setLoading] = useState(false);
    const {selectedIds, refetch} = useListContext();
    const handleSubmit = async (e: any) => {
        e.stopPropagation();
        setLoading(true);
        client(`delivery_administrative_block/change_status`, {
            method: "POST",
            data: {ids: selectedIds, status: status},
        })
            .then(() => {
                refetch();
                notify("Fatto", "success");
            })
            .catch(() => {
                notify("ra.message.error", "error");
            })
            .finally(() => {
                setLoading(false);
                setOpen(false);
            });
    };

    return (
        <>
            <ButtonRA
                {...props}
                disabled={loading || selectedIds.length <= 0}
                label="Cambia stato"
                onClick={handleClickOpen}
            >
                {loading ? <CircularProgress size={18} thickness={2}/> : <IoMdAddCircleOutline />}
            </ButtonRA>
            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">Cambia stato delle missioni selezionate</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <Select
                            label="Stato"
                            fullWidth
                            value={status}
                            onChange={(value) => setStatus(value.target.value as string)}
                        >
                            <MenuItem value="A">Approva</MenuItem>
                            <MenuItem value="R">Rifiuta</MenuItem>
                        </Select>
                        {status === "A" && <Typography>L'apporvazzione della missione bloccata, andra a creare una nuova missione.</Typography>}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                        Chiudi
                    </Button>
                    <Button onClick={handleSubmit} color="primary">
                        Cambia stato
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
